import {StylesProvider} from '@material-ui/core/styles';
import React, {PropsWithChildren} from 'react';

const LegacyStylesProvider = ({children}: PropsWithChildren<{}>) => (
  <StylesProvider injectFirst>{children}</StylesProvider>
);

export default LegacyStylesProvider;
